import React from 'react';
import {useTheme} from "../contexts/ThemeProvider";
import {HolidayEnum} from "../enums/holidayEnum";
import {HalloweenNet} from "./Holidays/HalloweenNet";
import {HalloweenBlurPage} from "./Holidays/HalloweenBlurPage";
import {HalloweenPageNet} from "./Holidays/HalloweenPageNet";
import pageRightNet from '../assets/halloween/pageRightNet.svg';
import pageLeftNet from '../assets/halloween/pageLeftNet.svg';
import FloatingIcon from "./FloatingIcon";
import styles from "../styles/FloatingIcon.module.scss";
import {ghosts} from "../constants/constants";

function HalloweenDecorator({children}) {
    const {theme} = useTheme()
    const isHalloween = theme.name === HolidayEnum.halloween;

    return (
        <>
            {children}
            {isHalloween && <HalloweenNet anchorId={'loginForm'}/>}
            {isHalloween &&
                <HalloweenPageNet
                    anchorId={'multiBrandPage'}
                    img={pageRightNet}
                    right={-1}
                    width={155}
                    height={172}
                />
            }
            {isHalloween &&
                <HalloweenPageNet
                    anchorId={'multiBrandPage'}
                    img={pageLeftNet}
                    left={-1}
                    width={110}
                    height={123}
                />
            }
            {isHalloween && <HalloweenBlurPage anchorId={'multiBrandPage'} zIndex={2}/>}
            {
                isHalloween && (
                    ghosts.map(ghost => (
                        <FloatingIcon
                            key={ghost.id}
                            className={styles.iconContainer}
                            src={ghost.src}
                            initialTopPct={ghost.top}
                            initialLeftPct={ghost.left}
                            speed={ghost.speed}
                            width={ghost.width}
                        />
                    ))
                )
            }
        </>
    );
}

export default HalloweenDecorator;